import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static values = { targetSelector: String }

   scrollTo(event) {
      event.preventDefault();
      const scrollTarget = document.querySelector(this.targetSelectorValue);
      scrollTarget.scrollIntoView({ behavior: "smooth" });
   }
}
